import { createSelector } from "reselect";
import get from "lodash/get";
import { getSignatories } from "./appConfig";
export const getStakeholdersState = state => state.stakeholders;
export const getEditableStakeholder = state => getStakeholdersState(state).editableStakeholder;
export const getStakeholdersIds = state => getStakeholdersState(state).stakeholdersIds;
export const getStakeholders = createSelector(
  getSignatories,
  getStakeholdersIds,
  (stakeholders, stakeholdersIds) =>
    stakeholders.map((item, index) => ({
      ...item,
      id: stakeholdersIds[index]
    }))
);
export const getPercentage = state => {
  const stakeholdersList = getSignatories(state);

  return stakeholdersList.reduce(
    (previousValue, currentValue) =>
      previousValue + Number(get(currentValue, "shareHoldingPercentage", 0)),
    0
  );
};
export const getPercentageWithoutCurrentStakeholder = (state, index) => {
  const signatories = [...getSignatories(state)];
  signatories.splice(index, 1);
  return signatories.reduce((acc, item) => acc + Number(get(item, "shareHoldingPercentage", 0)), 0);
};
export const checkIsHasSignatories = state =>
  getStakeholders(state).some(stakeholder => get(stakeholder, "isSignatory"));

export const checkIsShareholderACompany = state =>
  getStakeholders(state).some(stakeholder => get(stakeholder, "isShareholderACompany"));
